import './CustomerFeedbackPopup.css';
import { tTeamMember } from '../data/Team';

interface EmployeeQuitPopupProps {
  employee: tTeamMember;
  closeAndOpenHireCallback: () => void;
}

// Helper function to get job title (same logic as other components)
function getJobTitleForSkillLevel(skillLevel: number): string {
  enum eJobTitle {
    Trainee = 0.25,
    JuniorDeveloper = 0.5,
    JuniorSoftwareDeveloper = 0.75,
    Developer = 1,
    SoftwareEngineer = 1.25,
    SeniorSoftwareDeveloper = 1.5,
    LeadDeveloper = 1.75  
  }

  if (skillLevel >= eJobTitle.Trainee && skillLevel < eJobTitle.JuniorDeveloper) {
    return "Trainee";
  } else if (skillLevel >= eJobTitle.JuniorDeveloper && skillLevel < eJobTitle.JuniorSoftwareDeveloper) {
    return "Junior Developer";
  } else if (skillLevel >= eJobTitle.JuniorSoftwareDeveloper && skillLevel < eJobTitle.Developer) {
    return "Junior Software Developer";
  } else if (skillLevel === eJobTitle.Developer) {
    return "Developer";
  } else if (skillLevel > eJobTitle.Developer && skillLevel <= eJobTitle.SoftwareEngineer) {
    return "Software Engineer";
  } else if (skillLevel > eJobTitle.SoftwareEngineer && skillLevel <= eJobTitle.SeniorSoftwareDeveloper) {
    return "Senior Software Developer";
  } else if (skillLevel > eJobTitle.SeniorSoftwareDeveloper && skillLevel <= eJobTitle.LeadDeveloper) {
    return "Lead Developer";
  } else {
    return "Unknown Skill Level";
  }
}

export default function EmployeeQuitPopup(props: EmployeeQuitPopupProps) {
  const jobTitle = getJobTitleForSkillLevel(props.employee.level);
  
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>📤 Employee Departure</h3>
        
        {/* Employee file section */}
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ fontSize: '48px', marginRight: '15px' }}>{props.employee.icon}</span>
            <div>
              <h2 style={{ margin: '0 0 5px 0' }}>{props.employee.name}</h2>
              <p style={{ margin: '0', fontWeight: 'bold', color: '#666' }}>{jobTitle}</p>
            </div>
          </div>
          <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#fff3cd', borderRadius: '5px', borderLeft: '4px solid #ffc107' }}>
            <p style={{ margin: '0', color: '#856404' }}>
              <strong>{props.employee.name}</strong> has decided to leave the company for a new job opportunity. 
              As a senior member of the team, they have received an offer they couldn't refuse.
            </p>
          </div>
          <div style={{ marginTop: '10px' }}>
            <p style={{ margin: '5px 0' }}><strong>Specialty:</strong> {props.employee.skill}</p>
            <p style={{ margin: '5px 0' }}><strong>Level:</strong> {props.employee.level}</p>
          </div>
        </div>
        
        <button 
          className="close-button" 
          onClick={props.closeAndOpenHireCallback}
          style={{ width: '100%' }}
        >
          Find Replacement
        </button>
      </div>
    </div>
  );
}
